<ion-content>

  <ion-header>
    <ion-toolbar mode="ios">
      <ion-button (click)="close()" fill="clear" color="dark" class="ion-no-padding">
        <ion-icon slot="icon-only" name="chevron-back"></ion-icon>
      </ion-button>
      <ion-title class="ion-no-padding">
        <ion-img [src]="dataServ.rData.dark_logo" *ngIf="dataServ.rData.dark_logo[0]"></ion-img>
      </ion-title>
    </ion-toolbar>
  </ion-header>

  <ion-grid class="form">

    <ion-row>
      <ion-col size="12">
        <ion-text color="primary" class="ion-text-center">
          <h1><b>{{'Check-in' | translate}}</b></h1>
        </ion-text>
      </ion-col>
    </ion-row>

    <ion-row>

      <ion-img [src]="dataServ.rData.slider_images[0]"
        *ngIf="dataServ.rData && dataServ.rData.slider_images && dataServ.rData.slider_images.length > 0" class="bg">
      </ion-img>

      <ion-col size="12" *ngFor="let guest of checkInForm; let i = index">

        <form [formGroup]="guest">
          <ion-grid>
            <ion-row>

              <ion-col size="9" *ngIf="i > 0">
                <h3><b>{{i+1}}. {{'Guest' | translate}}</b></h3>
              </ion-col>
              <ion-col size="3" *ngIf="i > 0">
                <ion-button (click)="checkInForm.splice(i,1)" expand="block" fill="clear" color="danger">
                  {{'Remove' | translate}}
                </ion-button>
              </ion-col>

              <ng-container>
                <ion-col size="6">
                  <ion-item>
                    <ion-label position="stacked">{{'Name' | translate}} <ion-text color="danger">*</ion-text>
                    </ion-label>
                    <ion-input formControlName="name"></ion-input>
                  </ion-item>
                </ion-col>

                <ion-col size="6">
                  <ion-item>
                    <ion-label position="stacked">{{'Surname' | translate}} <ion-text color="danger">*</ion-text>
                    </ion-label>
                    <ion-input formControlName="surname"></ion-input>
                  </ion-item>
                </ion-col>

                <ion-col size="6">
                  <ion-item>
                    <ion-label position="stacked">{{'Check-in' | translate}} <ion-text color="danger">*</ion-text>
                    </ion-label>
                    <ion-datetime display-format="DD.MM.YYYY" formControlName="checkin"></ion-datetime>
                  </ion-item>
                </ion-col>

                <ion-col size="6">
                  <ion-item>
                    <ion-label position="stacked">{{'Check-out' | translate}} <ion-text color="danger">*</ion-text>
                    </ion-label>
                    <ion-datetime display-format="DD.MM.YYYY" formControlName="checkout"></ion-datetime>
                  </ion-item>
                </ion-col>

                <ion-col size="12">
                  <ion-item>
                    <ion-label position="stacked">{{'Date of Birth' | translate}} <ion-text color="danger">*</ion-text>
                    </ion-label>
                    <ion-datetime [max]="maxTime" display-format="DD.MM.YYYY" formControlName="birthdate">
                    </ion-datetime>
                  </ion-item>
                </ion-col>

                <ion-col size="12">
                  <ion-item>
                    <ion-label position="stacked">{{'Email' | translate}} <ion-text color="danger">*</ion-text>
                    </ion-label>
                    <ion-input formControlName="email" type="email"></ion-input>
                  </ion-item>
                </ion-col>

                <ion-col size="12">
                  <ion-item>
                    <ion-label position="stacked">{{'Phone' | translate}}
                    </ion-label>
                    <ion-input formControlName="phone"></ion-input>
                  </ion-item>
                </ion-col>

                <ion-col size="12">
                  <ion-item>
                    <ion-label position="stacked">{{'Identity Number' | translate}}
                    </ion-label>
                    <ion-input formControlName="idno"></ion-input>
                  </ion-item>
                </ion-col>

                <ion-col size="12">
                  <ion-item>
                    <ion-label position="stacked">{{'Vehicle No' | translate}}
                    </ion-label>
                    <ion-input formControlName="vehicleno"></ion-input>
                  </ion-item>
                </ion-col>

                <ion-col size="12">
                  <ion-item>
                    <ion-label position="stacked">{{'Address' | translate}} <ion-text color="danger">*</ion-text>
                    </ion-label>
                    <ion-textarea rows="2" formControlName="address"></ion-textarea>
                  </ion-item>
                </ion-col>

                <ion-col size="6">
                  <ion-item>
                    <ion-label position="stacked">{{'City' | translate}} <ion-text color="danger">*</ion-text>
                    </ion-label>
                    <ion-input formControlName="city"></ion-input>
                  </ion-item>
                </ion-col>

                <ion-col size="6">
                  <ion-item>
                    <ion-label position="stacked">{{'Country' | translate}} <ion-text color="danger">*</ion-text>
                    </ion-label>
                    <ion-input formControlName="country"></ion-input>
                  </ion-item>
                </ion-col>

                <ion-col size="12">
                  <ion-item>
                    <ion-label position="stacked">{{'Gender' | translate}}
                    </ion-label>
                    <ion-select formControlName="gender">
                      <ion-select-option value="male">{{'Male' | translate}}</ion-select-option>
                      <ion-select-option value="female">{{'Female' | translate}}</ion-select-option>
                    </ion-select>
                  </ion-item>
                </ion-col>

                <ion-col size="12">
                  <ion-item>
                    <ion-label>{{'Allergy' | translate}}
                    </ion-label>
                    <ion-toggle slot="end" formControlName="allergies"></ion-toggle>
                  </ion-item>
                </ion-col>

                <ion-col size="12" *ngIf="guest.controls.allergies.value">
                  <ion-item>
                    <ion-label position="stacked">{{'Allergy Description' | translate}} <ion-text color="danger">*
                      </ion-text>
                    </ion-label>
                    <ion-textarea rows="2" formControlName="alleryDesc"></ion-textarea>
                  </ion-item>
                </ion-col>

                <ng-container *ngIf="dataServ.rData.online_check_in_signature">
                  <ion-col size="12">
                    <ion-item
                      (click)="signature.style.display !== 'none' ? signature.style.display = 'none' : signature.style.display = 'block'">
                      <ion-label>{{'Signature' | translate}}
                      </ion-label>
                      <ion-icon slot="end" name="pencil" color="primary"></ion-icon>
                    </ion-item>

                  </ion-col>

                  <ion-col size="12">
                    <div #signature [style.display]="'none'" class="sign-div">
                      <div class="text" #signText>
                        <ion-icon name="pencil" color="primary"></ion-icon>
                        <ion-text color="primary">
                          <h3><b>{{'Please Sign Here' | translate}}</b></h3>
                        </ion-text>
                      </div> 

                      <signature-pad #signPad (drawEnd)="guest.controls.signature.setValue(signPad.toDataURL())"
                        (drawStart)="signText.style.display = 'none'"></signature-pad>

                      <ion-button *ngIf="guest.controls.signature.value"
                        (click)="signPad.clear(); guest.controls.signature.setValue(null)" expand="block" fill="clear">
                        {{'Clear' | translate}}
                      </ion-button>
                    </div>
                  </ion-col>
                </ng-container>

                <ng-container *ngIf="dataServ.rData.online_check_in_image">
                  <input type="file" #frontInput accept="image/*"
                    (change)="uploadPhoto(frontInput.files[0], 'front', guest)" class="ion-hide">
                  <ion-col size="12">
                    <ion-item (click)="frontInput.click()">
                      <ion-label text-wrap>{{'Passport/Id Card Front Image' | translate}}
                      </ion-label>
                      <ion-icon slot="end" name="camera" color="primary"></ion-icon>
                    </ion-item>
                  </ion-col>

                  <ion-col size="12" *ngIf="guest.controls.passportFront.value">
                    <ion-img [src]="guest.controls.passportFront.value"></ion-img>

                    <ion-button (click)="guest.controls.passportFront.setValue(null)" expand="block" fill="clear">
                      {{'Clear' | translate}}
                    </ion-button>
                  </ion-col>

                  <input type="file" #backInput accept="image/*"
                    (change)="uploadPhoto(backInput.files[0], 'back', guest)" class="ion-hide">
                  <ion-col size="12">
                    <ion-item (click)="backInput.click()">
                      <ion-label text-wrap>{{'Passport/Id Card Back Image' | translate}}
                      </ion-label>
                      <ion-icon slot="end" name="camera" color="primary"></ion-icon>
                    </ion-item>
                  </ion-col>

                  <ion-col size="12" *ngIf="guest.controls.passportBack.value">
                    <ion-img [src]="guest.controls.passportBack.value"></ion-img>

                    <ion-button (click)="guest.controls.passportBack.setValue(null)" expand="block" fill="clear">
                      {{'Clear' | translate}}
                    </ion-button>
                  </ion-col>
                </ng-container>


                <ion-col size="12">
                  <ion-item>
                    <ion-label>{{'Invoice Info' | translate}}
                    </ion-label>
                    <ion-toggle slot="end" formControlName="invoiceInf"></ion-toggle>
                  </ion-item>
                </ion-col>

                <ng-container *ngIf="guest.controls.invoiceInf.value">
                  <ion-col size="12">
                    <ion-item>
                      <ion-label position="stacked">{{'Company Name' | translate}} <ion-text color="danger">*
                        </ion-text>
                      </ion-label>
                      <ion-input formControlName="companyName"></ion-input>
                    </ion-item>
                  </ion-col>
                  <ion-col size="12">
                    <ion-item>
                      <ion-label position="stacked">{{'Staff Name' | translate}} <ion-text color="danger">*
                        </ion-text>
                      </ion-label>
                      <ion-input formControlName="staffName"></ion-input>
                    </ion-item>
                  </ion-col>
                  <ion-col size="12">
                    <ion-item>
                      <ion-label position="stacked">{{'Identity Number' | translate}} <ion-text color="danger">*
                        </ion-text>
                      </ion-label>
                      <ion-input formControlName="idNo"></ion-input>
                    </ion-item>
                  </ion-col>
                  <ion-col size="12">
                    <ion-item>
                      <ion-label position="stacked">{{'Tax Area' | translate}} <ion-text color="danger">*
                        </ion-text>
                      </ion-label>
                      <ion-input formControlName="taxArea"></ion-input>
                    </ion-item>
                  </ion-col>
                  <ion-col size="12">
                    <ion-item>
                      <ion-label position="stacked">{{'Tax Number' | translate}} <ion-text color="danger">*
                        </ion-text>
                      </ion-label>
                      <ion-input formControlName="taxNo"></ion-input>
                    </ion-item>
                  </ion-col>
                  <ion-col size="12">
                    <ion-item>
                      <ion-label position="stacked">{{'Company Address' | translate}} <ion-text color="danger">*
                        </ion-text>
                      </ion-label>
                      <ion-input formControlName="companyAddress"></ion-input>
                    </ion-item>
                  </ion-col>
                  <ion-col size="12">
                    <ion-item>
                      <ion-label position="stacked">{{'Company Email' | translate}} <ion-text color="danger">*
                        </ion-text>
                      </ion-label>
                      <ion-input formControlName="companyEmail"></ion-input>
                    </ion-item>
                  </ion-col>
                </ng-container>


              </ng-container>
            </ion-row>
          </ion-grid>
        </form>

      </ion-col>

      <ion-col size="12" class="kvkk">
        <ion-item>
          <ion-checkbox [(ngModel)]="terms" value="true" slot="start" mode="md"></ion-checkbox>
          <ion-label text-wrap>
            <a (click)="modalServ.openLink(dataServ.rData.privacy_policy_link)">
              {{'I have read and accept the Terms & Conditions and Privacy Policy.' | translate}}</a>
          </ion-label>
        </ion-item>
        <ion-item>
          <ion-checkbox [(ngModel)]="kvkk" value="true" slot="start" mode="md"></ion-checkbox>
          <ion-label text-wrap>
            <a (click)="modalServ.openLink(dataServ.rData.kvkk_link)">{{'kvkk' | translate}}</a>
          </ion-label>
        </ion-item>
      </ion-col>

      <ion-col size="6" class="bottom">
        <div class="square">
          <ion-icon name="add" color="primary"></ion-icon>
        </div>
        <ion-button (click)="addPerson()" expand="block" color="primary">
          {{'Add Person' | translate}}
        </ion-button>
      </ion-col>

      <ion-col size="6" class="bottom">
        <div class="square">
          <ion-icon name="log-in-outline" color="primary"></ion-icon>
        </div>
        <ion-button [disabled]="processing || !kvkk || !terms" (click)="checkin()" expand="block" color="primary">
          {{'Check-in' | translate}}
          <ion-spinner name="lines" slot="end" *ngIf="processing"></ion-spinner>
        </ion-button>
      </ion-col>

    </ion-row>


  </ion-grid>
</ion-content>